import * as React from 'react';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import MoneyView from 'shared/components/MoneyView';
import { formatNumber } from 'shared/components/NumberView';
import { FormatNumberOptions } from 'shared/components/NumberView/format';

export interface Props {
  className?: string;
  min: number;
  max: number;
}

const Range: React.SFC<Props & InjectedTranslateProps> = ({ t, language, min, max, className }) => {
  if (!isFinite(max)) {
    return (
      <div className={className}>
        {t('From')} <MoneyView compactNotation>{{ value: min, currency: 'USD' }}</MoneyView>
      </div>
    );
  }
  if (!min) {
    return (
      <div className={className}>
        {t('To')} <MoneyView compactNotation>{{ value: max, currency: 'USD' }}</MoneyView>
      </div>
    );
  }
  const options: FormatNumberOptions = {
    language,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    compactNotation: true,
  };
  const minParts = formatNumber(min, options);
  const maxParts = formatNumber(max, options);

  const isSameName = minParts.name && maxParts.name && minParts.name === maxParts.name;

  return (
    <div className={className}>
      {minParts.integer} {!isSameName && t(minParts.name)}
      {'—'}
      {maxParts.integer} {t(maxParts.name)} $
    </div>
  );
};

export default translate(Range);
